import React from 'react';
import { useImageUrl } from '@shared/components/ImageContext';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import styles from './StatusDialog.module.scss';

export interface StatusDialogProps {
  title: string;
  lead: string;
  detail: string;
  action?: { label: string; onClick: () => void };
  onClose: () => void;
}

// Waiting on the socket or the wallet, not on the player.
const StatusDialog: React.FC<StatusDialogProps> = ({
  title,
  lead,
  detail,
  action,
  onClose,
}) => {
  const { t } = useTranslation();
  const { img, imgProps } = useImageUrl();

  return (
    <div className={styles.scrim}>
      <div
        className={styles.dialog}
        style={
          { '--panel-skin': `url(${img('PopupFrame')})` } as React.CSSProperties
        }
      >
        <div className={styles.head}>
          <h2 className={styles.title}>{title}</h2>
          <button
            type="button"
            className={styles.close}
            aria-label={t('Close')}
            onClick={onClose}
          >
            <img {...imgProps('Icon_Close')} alt="" />
          </button>
        </div>

        <div className={styles.status}>
          <img {...imgProps('Icon_Reconnect')} alt="" />
        </div>

        <p className={styles.lead}>{lead}</p>
        <p className={styles.detail}>{detail}</p>

        {action && (
          <button
            type="button"
            className={cn(styles.skin, styles.skin_primary)}
            style={
              {
                '--button-skin': `url(${img('ButtonSkin_Primary')})`,
              } as React.CSSProperties
            }
            onClick={action.onClick}
          >
            {action.label}
          </button>
        )}
      </div>
    </div>
  );
};

export default StatusDialog;
